import React from 'react'
import Home from './Components/Home';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Details from './Components/Details';
function App() {
  return (
    
    <Routes>
      
        <Route exact path="/" element={<Home />} />
        <Route path="/movies/:id" element={<Details />} />
       
      
    </Routes>
  )
}

export default App